class CurrentLocation {
  constructor() {
    this.apiUrl = "https://nominatim.openstreetmap.org/reverse";
    this.locationElements = document.querySelectorAll("current-location");
    this.wrapperElements = document.querySelectorAll("current-location-only");
    this.cookieName = "current_location";
    this.cookieHours = 6; // cookie validity in hours

    this.init();
  }

  async init() {
    const cachedLocation = this.getCookie(this.cookieName);
    if (cachedLocation) {
      console.log("[CurrentLocation] Using cached:", cachedLocation);
      this.render(cachedLocation);
      this.showWrappers();
      return;
    }

    try {
      const position = await this.getPosition();
      const { latitude, longitude } = position.coords;
      const location = await this.getCityAndState(latitude, longitude);

      if (location) {
        this.setCookie(this.cookieName, location, this.cookieHours);
        this.render(location);
        this.showWrappers();
      } else {
        this.hideWrappers();
      }
    } catch (error) {
      console.warn("[CurrentLocation] Error:", error);
      this.hideWrappers();
    }
  }

  getPosition() {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation not supported"));
      } else {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 8000,
        });
      }
    });
  }

  async getCityAndState(lat, lon) {
    const params = new URLSearchParams({
      lat,
      lon,
      format: "json",
      addressdetails: 1,
      "accept-language": "pt-BR",
    });

    const response = await fetch(`${this.apiUrl}?${params.toString()}`, {
      headers: { "User-Agent": "LocationFetcher/1.0" },
    });

    if (!response.ok) throw new Error("Erro ao buscar localização");

    const data = await response.json();
    const city = data.address.city || data.address.town || data.address.village;
    const state = data.address.state || data.address.region;

    if (!city || !state) return null;

    const stateCode = this.getStateCode(state);
    return `${city} - ${stateCode}`;
  }

  getStateCode(stateName) {
    const states = {
      "Acre": "AC", "Alagoas": "AL", "Amapá": "AP", "Amazonas": "AM", "Bahia": "BA",
      "Ceará": "CE", "Distrito Federal": "DF", "Espírito Santo": "ES", "Goiás": "GO",
      "Maranhão": "MA", "Mato Grosso": "MT", "Mato Grosso do Sul": "MS", "Minas Gerais": "MG",
      "Pará": "PA", "Paraíba": "PB", "Paraná": "PR", "Pernambuco": "PE", "Piauí": "PI",
      "Rio de Janeiro": "RJ", "Rio Grande do Norte": "RN", "Rio Grande do Sul": "RS",
      "Rondônia": "RO", "Roraima": "RR", "Santa Catarina": "SC", "São Paulo": "SP",
      "Sergipe": "SE", "Tocantins": "TO",
    };
    return states[stateName] || stateName;
  }

  render(text) {
    this.locationElements.forEach((el) => {
      el.textContent = text;
    });
  }

  showWrappers() {
    this.wrapperElements.forEach((el) => {
      el.style.display = "flex";
    });
  }

  hideWrappers() {
    this.wrapperElements.forEach((el) => {
      el.style.display = "none";
    });
  }

  // --- Cookie helpers ---
  setCookie(name, value, hours) {
    const d = new Date();
    d.setTime(d.getTime() + hours * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/`;
  }

  getCookie(name) {
    const cookies = document.cookie.split(";").map(c => c.trim());
    for (let cookie of cookies) {
      if (cookie.startsWith(`${name}=`)) {
        return decodeURIComponent(cookie.split("=")[1]);
      }
    }
    return null;
  }
}

// ✅ Initialize automatically
document.addEventListener("DOMContentLoaded", () => new CurrentLocation());
